import Vue from 'vue';
import Vuex from 'vuex';
import Elements from './elements.json';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    elements: Elements
  },
  mutations: {},
  actions: {},
  modules: {}
});